import { useStore } from "@core/store";
import { useAuthStore } from "@core/store/storeAuth";
import { useShallow } from "zustand/react/shallow";

export const useCloseSession = () => {
  const { logout } = useAuthStore(
    useShallow((state) => ({
      logout: state.logout,
    })),
  );

  const { setAddress, unsubscribeTopics } = useStore(
    useShallow((state) => ({
      setAddress: state.setAddress,
      unsubscribeTopics: state.unsubscribeTopics,
    })),
  );

  const closeSession = async () => {
    setAddress?.("");
    unsubscribeTopics?.();
    await logout();
  };

  return closeSession;
};
